import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const TestimonialsManager = () => {
  const { toast } = useToast();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Testimonials</CardTitle>
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          New Testimonial
        </Button>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Testimonials management coming soon...</p>
      </CardContent>
    </Card>
  );
};

export default TestimonialsManager;
